import { connect } from 'react-redux';
import _ from 'lodash';
import NoDeviceMessage from '../components/no_device_message/no_device_message';

function mapStateToProps({ devices, slack, facebook }) {
  const fbPages = _.values(facebook.pages);
  const sources = _.compact([...fbPages, slack.team]);
  return {
    devicesCount: _.size(devices.pairedDevices),
    sourcesCount: _.size(sources),
  };
}

export default connect(mapStateToProps)(NoDeviceMessage);



// WEBPACK FOOTER //
// ./src/containers/no_device_message.js